import { render, staticRenderFns } from "./Labelling.vue?vue&type=template&id=55406836"
import script from "./Labelling.vue?vue&type=script&lang=js"
export * from "./Labelling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports